import { render, staticRenderFns } from "./my-information-form.vue?vue&type=template&id=331a2fe6&scoped=true"
import script from "./my-information-form.vue?vue&type=script&lang=js"
export * from "./my-information-form.vue?vue&type=script&lang=js"
import style0 from "./my-information-form.scss?vue&type=style&index=0&id=331a2fe6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a2fe6",
  null
  
)

export default component.exports